import { render, staticRenderFns } from "./Item59Effilabel.vue?vue&type=template&id=8d3bdf36&scoped=true&"
import script from "./Item59Effilabel.vue?vue&type=script&lang=js&"
export * from "./Item59Effilabel.vue?vue&type=script&lang=js&"
import style0 from "./Item59Effilabel.vue?vue&type=style&index=0&id=8d3bdf36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3bdf36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VBtnToggle,VCard,VDivider,VFlex,VImg,VLayout,VProgressLinear})
